import PropTypes from 'prop-types';
// @mui
import { alpha, styled } from '@mui/material/styles';
import { Card, Stack, Typography } from '@mui/material';
// utils
import { fShortenNumber } from '../../../../utils/formatNumber';
// components
import Iconify from '../../../../components/Iconify';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme, ownerState }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2.5, 3),
  boxShadow: 'none',
  backgroundColor: alpha(theme.palette[ownerState.color].main, 0.12),
}));

const IconWrapperStyle = styled('div')(({ theme, ownerState }) => ({
  width: 44,
  height: 44,
  flexShrink: 0,
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: theme.spacing(2),
  color: theme.palette[ownerState.color].dark,
  backgroundColor: alpha(theme.palette[ownerState.color].main, 0.24),
}));

// ----------------------------------------------------------------------

WidgetSummary.propTypes = {
  title: PropTypes.string,
  total: PropTypes.number,
  icon: PropTypes.string,
  color: PropTypes.oneOf(['primary', 'secondary', 'info', 'success', 'warning', 'error']),
};

export default function WidgetSummary({ title, total, icon = 'eva:pie-chart-2-fill', color = 'primary' }) {
  const ownerState = { color };

  return (
    <RootStyle ownerState={ownerState}>
      <IconWrapperStyle ownerState={ownerState}>
        <Iconify icon={icon} width={22} height={22} />
      </IconWrapperStyle>
      <Stack spacing={0.25}>
        <Typography variant="h3">{fShortenNumber(total)}</Typography>
        <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
          {title}
        </Typography>
      </Stack>
    </RootStyle>
  );
}
